// src/App.js
import React, {useEffect} from 'react';
import Nav from './Components/Nav';
import Home from './Components/Home';
// import Work from './Components/Work';
import Publications from './Components/Publications';
// import Contact from './Components/Contact';
import News from './Components/News'

function App() {
  useEffect(() => {
    const bibbase = document.getElementById('bibbase');
    const publicationsDiv = document.getElementById('publications');
    publicationsDiv.parentNode.insertBefore(bibbase, publicationsDiv.nextSibling);
  
  }, []);

  return (
    <div>
      <Nav />
      <Home />
      {/* <Work /> */}
      <News/>
      <Publications />
      <span className="spacing"></span>
      {/* <Contact /> */}
    </div>
  );
}

export default App;